<template>
  <f7-page>
    <a
      class="fixed right-0 m-5 rounded-full shadow-lg p-2 leading-3 bg-purple-500"
      @click.prevent="$f7router.back()"
    >
      <eva-icon
        name="close-outline"
        fill="#FFFFFF"
        width="32"
        height="32"
      />
    </a>
    <div class="mx-auto w-11/12 sm:w-9/12 sm:min-w-150 mt-2 sm:mt-12 max-w-4xl">
      <div
        class="mx-auto my-10 sm:flex justify-between max-w-2xl"
      >
        <img
          class="w-24"
          src="@/assets/qr-code.png"
          style="filter: invert(45%) sepia(80%) saturate(4244%) hue-rotate(228deg) brightness(101%) contrast(103%)"
        >
        <div
          class="text-4xl font-bold mx-10"
        >
          QR configurador de wifi
        </div>
      </div>
      <div>
        Para vincular un dispositivo solo debes leer el codigo QR de acuerdo a la red a la que se debe conectar.
      </div>
      <div class="flex items-center">
        <div class="text-xl font-bold my-6">
          Codigos Generados
        </div>
        <a
          href="#"
          class="block ml-4 p-2 bg-green-500 rounded-md"
          @click="openModal=true"
        >
          <eva-icon
            class="align-middle"
            name="plus-outline"
            fill="#FFFFFF"
          />
          <span class="text-white text-lg align-text-top">Nuevo</span>
        </a>
      </div>
      <div v-if="codes.length > 0">
        <div class="flex flex-wrap">
          <qr-card
            v-for="code in codes"
            :key="code.id"
            :codeID="code.id"
            :data="code.data"
            :title="code.ssid"
            class="ml-4 mt-4"
          >
            {{ code.ssid }}
          </qr-card>
        </div>
      </div>
      <div
        v-else
        class="text-center mt-16"
      >
        <img
          class="mx-auto w-3/6 opacity-50"
          src="@/assets/empty.svg"
          alt="Empty"
        >
        <div class="mt-4 text-lg text-center">
          ¡Vaya! Aun no tienes codigos creados.
        </div>
      </div>
    </div>
    <portal to="modals">
      <modal
        :open="openModal"
        type="custom"
        @close="openModal = false; resetForm()"
      >
        <div
          slot="content"
        >
          <div
            class="text-xl font-bold mr-4 p-8"
          >
            <div class="mb-8 text-center">
              Datos de la red WIFI
            </div>
            <form @submit="newQR">
              <label
                class="text-xl font-normal w-full"
              >SSID<span class="text-red-500">*</span>
                <input
                  v-model="ssid"
                  name="ssid"
                  type="text"
                  required
                  class="border rounded-sm p-1 focus:border-purple-500 w-full mb-4"
                >
              </label>
              <label
                class="text-xl font-normal w-full"
              >contraseña<span class="text-red-500">*</span>
                <input
                  v-model="password"
                  name="password"
                  type="password"
                  required
                  class="border rounded-sm p-1 focus:border-purple-500 w-full mb-4"
                >
              </label>
              <label
                class="text-xl font-normal w-full"
              >IP
                <input
                  v-model="ip"
                  name="IP"
                  type="text"
                  minlength="7"
                  maxlength="15"
                  size="15"
                  pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$"
                  class="border rounded-sm p-1 focus:border-purple-500 w-full mb-4"
                >
              </label>
              <label
                class="text-xl font-normal w-full"
              >Mascara de red
                <input
                  v-model="subnet"
                  name="subnet"
                  type="text"
                  minlength="7"
                  maxlength="15"
                  size="15"
                  pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$"
                  class="border rounded-sm p-1 focus:border-purple-500 w-full mb-4"
                >
              </label>
              <label
                class="text-xl font-normal w-full"
              >Puerta de enlace
                <input
                  v-model="gateway"
                  name="gateway"
                  type="text"
                  minlength="7"
                  maxlength="15"
                  size="15"
                  pattern="^((\d{1,2}|1\d\d|2[0-4]\d|25[0-5])\.){3}(\d{1,2}|1\d\d|2[0-4]\d|25[0-5])$"
                  class="border rounded-sm p-1 focus:border-purple-500 w-full mb-4"
                >
              </label>
              <div class="flex">
                <a
                  class="disabled:opacity-25 disabled:pointer-events-none block w-56 h-16 leading-16 text-gray-500 text-center text-2xl rounded-lg mx-auto my-10 font-normal"
                  @click="openModal=false"
                >
                  Cancelar
                </a>
                <button
                  :disabled="!canSend"
                  type="submit"
                  class="disabled:opacity-25 disabled:pointer-events-none block w-56 h-16 leading-16 bg-purple-500 text-white text-center text-2xl rounded-lg mx-auto my-10"
                >
                  Generar QR
                </button>
              </div>
            </form>
          </div>
        </div>
      </modal>
    </portal>
  </f7-page>
</template>

<script>
import { db } from '../utils/firebase'
import { mapState } from 'vuex'
import QrCard from '../components/qrCard'
import Modal from '../components/modal'
import * as axios from 'axios'

export default {
  components: {
    QrCard,
    Modal,
  },
  data () {
    return {
      codes: [],
      openModal: false,
      ssid: null,
      password: null,
      ip: null,
      subnet: null,
      gateway: null,
    }
  },
  computed: {
    canSend () {
      return this.ssid && this.password
    },
    ...mapState({
      instanceID: state => state.admin.instanceID,
      instancesInfo: state => state.auth.instancesInfo,
    }),
  },
  mounted () {
    db.collection('instances').doc(this.instanceID).collection('generatedConfig')
      .where('type', '==', 'linkNetwork').orderBy('created_at', 'desc').onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === 'added') {
            this.codes.push({
              id: change.doc.id,
              ...change.doc.data(),
            })
          } else if (change.type === 'changed') {
            this.codes.splice(this.codes.findIndex(code => code.id === change.doc.id), 1, {
              id: change.doc.id,
              ...change.doc.data(),
            })
          } else if (change.type === 'removed') {
            this.codes = this.codes.filter(code => code.id !== change.doc.id)
          }
        })
      })
  },
  methods: {
    resetForm () {
      this.ssid = null
      this.password = null
      this.ip = null
      this.subnet = null
      this.gateway = null
    },
    async newQR (e) {
      e.preventDefault()
      this.openModal = false
      try {
        this.$f7.dialog.preloader('Encriptación AES...')
        const response = await axios({
          url: '/device/netWorkLinkGenerator',
          method: 'POST',
          data: {
            ssid: this.ssid,
            password: this.password,
            type: 'linkNetwork',
            instanceID: this.instanceID,
            ...(this.ip && { ip: this.ip, subnet: this.subnet, gateway: this.gateway }),
          },
        })
        console.info(response)
      } catch (error) {
        console.error(error)
      } finally {
        this.resetForm()
        this.$f7.dialog.close()
      }
    },
  },
}
</script>
